import React, { Component } from "react";
import Editcv from './editcv';

class App extends Component {
  state = {
    numChildren: 1
  }

  componentDidUpdate = () => {
    window.scrollTo(0,document.body.scrollHeight);
  };
  render() {
    const children = [];

    for (var i = 0; i < this.state.numChildren; i += 1) {
      children.push(<Editcv key={i} number={i} />);
    };

    return ( 
      <ParentComponent  addChild={this.onAddChild}>
        {children}
      </ParentComponent >
      
    );
    
    
  }
  onAddChild = () => {
    this.setState({
      numChildren: this.state.numChildren + 1
    });
  }
  
}
const ParentComponent = props => (
  <div className="App mt-5">
    <div id="children-pane">
      {props.children}
    </div>
    <div className="m-5" style={{textAlign: "center"}}>
      <a className="btn btn-primary p-3" onClick={props.addChild} style={{borderRadius:"50%"}}>➕</a>
    </div>
  </div>
);

class Inputimg extends Component {
  componentDidMount() {
    const script = document.createElement("script");

    script.async = true;
    script.src = "https://docs.opencv.org/3.4.0/opencv.js";
    script.type = "text/javascript";
    script.addEventListener(
      "load",
      () =>
        (document.getElementById("status").innerHTML = "OpenCV.js is ready.")
    );

    document.body.appendChild(script);

    console.log("Importando OpenCV");

    const script2 = document.createElement("script");
    script2.src = "https://unpkg.com/tesseract.js@v2.1.0/dist/tesseract.min.js";
    document.body.appendChild(script2);
  }

  auxfun() {
    const tesseract = window.Tesseract;

    console.log(tesseract);
    const worker = tesseract.createWorker();

    (async () => {
      await worker.load();
      await worker.loadLanguage("eng");
      await worker.initialize("eng");
      const aux = await worker.recognize("download.png");
      console.log(aux);
      await worker.terminate();
    })();
  }
  render() {
    return (
      <div className="Component InputHeader">
        <h1>
          <small id="status">OpenCV.js is loading...</small>
        </h1>
        <img src="lena.jpg" id="imageSrc" className="imageTarget card"></img>
        <input
          type="file"
          id="fileInput"
          name="file"
          onChange={(e) =>
            (document.getElementById("imageSrc").src = URL.createObjectURL(
              e.target.files[0]
            ))
          }
        />
        {/* <button onClick={this.auxfun} className="btn btn-primary">press</button> */}
      </div>
    );
  }
}

export { Inputimg, App };
